import { render, staticRenderFns } from "./eventRequestDetails.vue?vue&type=template&id=2b77d894&scoped=true"
import script from "./eventRequestDetails.vue?vue&type=script&lang=js"
export * from "./eventRequestDetails.vue?vue&type=script&lang=js"
import style0 from "./eventRequestDetails.vue?vue&type=style&index=0&id=2b77d894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b77d894",
  null
  
)

export default component.exports